var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 18958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 18956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1191",
    d: "M1.5 8C1.5 9.28558 1.88122 10.5423 2.59545 11.6112C3.30968 12.6801 4.32484 13.5132 5.51256 14.0052C6.70028 14.4972 8.00721 14.6259 9.26809 14.3751C10.529 14.1243 11.6872 13.5052 12.5962 12.5962C13.5052 11.6872 14.1243 10.529 14.3751 9.26809C14.6259 8.00721 14.4972 6.70028 14.0052 5.51256C13.5132 4.32484 12.6801 3.30968 11.6112 2.59545C10.5423 1.88122 9.28558 1.5 8 1.5V3.03527C8.98193 3.03527 9.94181 3.32645 10.7583 3.87198C11.5747 4.41751 12.211 5.1929 12.5868 6.10008C12.9626 7.00727 13.0609 8.00551 12.8693 8.96857C12.6778 9.93163 12.2049 10.8163 11.5106 11.5106C10.8163 12.2049 9.93163 12.6778 8.96857 12.8693C8.00551 13.0609 7.00727 12.9626 6.10008 12.5868C5.1929 12.211 4.41751 11.5747 3.87198 10.7583C3.32645 9.94181 3.03527 8.98193 3.03527 8H1.5Z",
    fill: "#646B87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1196",
    d: "M2.90419 3.96482C2.39697 4.60536 2.01506 5.33579 1.77847 6.11783L3.29343 6.57614C3.47241 5.98453 3.76132 5.43197 4.14503 4.9474L2.90419 3.96482Z",
    fill: "#646B87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1197",
    d: "M6.36067 1.71012C5.57003 1.91618 4.82534 2.26946 4.1656 2.75144L5.08815 4.01423C5.58915 3.64821 6.15468 3.37993 6.75509 3.22345L6.36067 1.71012Z",
    fill: "#646B87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInProgress);
export default __webpack_public_path__ + "static/media/ic_in-progress.5f2abaa21e5326f438370523f4271768.svg";
export { ForwardRef as ReactComponent };